var auth2; // The Sign-In object.
var googleUser; // The current user.

/**
 * Initializes the Sign-In client.
 */
window.initClient = function (googleId) {
	if (!googleId) {
		console.error('Google Client ID is not provided');
		return;
	}

	// Wait for the Google API to load
	function waitForGoogleAPI() {
		if (typeof gapi !== 'undefined') {
			initializeAuth2();
		} else {
			setTimeout(waitForGoogleAPI, 100);
		}
	}

	function initializeAuth2() {
		try {
			gapi.load('auth2', function() {
				gapi.auth2.init({
					client_id: googleId,
					scope: 'email profile'
				}).then(function(authInstance) {
					auth2 = authInstance;
					
					// Listen for sign-in state changes
					auth2.isSignedIn.listen(signinChanged);
					auth2.currentUser.listen(userChanged);
					
					// Attach click handlers to Google Sign-In buttons
					attachSignIn(document.getElementById('customBtn'));
					attachSignIn(document.getElementById('customBtnRegister'));
					
					// Refresh values if user is already signed in
					refreshValues();
				}).catch(function(error) {
					console.error('Error initializing Google Auth2:', error);
				});
			});
		} catch (error) {
			console.error('Error loading Google Auth2:', error);
		}
	}

	function attachSignIn(element) {
		if (!element) return;
		
		element.addEventListener('click', function() {
			var auth2 = gapi.auth2.getAuthInstance();
			auth2.signIn().then(function(googleUser) {
				var profile = googleUser.getBasicProfile();
				var id = profile.getId();
				var email = profile.getEmail();
				var name = profile.getGivenName();
				var surname = profile.getFamilyName();
				var gender = null; // Google API doesn't provide gender
				var birthdate = null; // Google API doesn't provide birthdate
				
				loginSocialNetworkUser(id, "google", email, name, surname, gender, birthdate, null);
			}).catch(function(error) {
				console.error('Error signing in with Google:', error);
			});
		});
	}

	// Start waiting for Google API
	waitForGoogleAPI();
}

/**
 * Handle successful sign-ins.
 */
var onSuccess = function(user) {
    console.log('Signed in as ' + JSON.stringify(auth2.currentUser.get(), undefined, 2));
    window.parent.loginSocialNetworkUser(user.getAuthResponse().id_token,"google",user.getBasicProfile().getEmail(),null,null,0,null,null);
    
};

/**
 * Handle sign-in failures.
 */
var onFailure = function(error) {
    console.log(error);
};

/**
 * Listener method for sign-out live value.
 */
function signinChanged(val) {
	console.log('Signin state changed to ', val);
}

/**
 * Listener method for when the user changes.
 */
function userChanged(user) {
	updateGoogleUser(user);
}

/**
 * Updates the properties in the Google User table using the current user.
 */
function updateGoogleUser(user) {
	googleUser = user;
	if (googleUser) {
		console.log('user-id:' + googleUser.getId());
	} else {
		console.log('user-id:--');
	}
}

/**
 * Retrieves the current user and signed in states from the GoogleAuth object.
 */
function refreshValues() {
	if (auth2) {
		console.log('Refreshing values...');
		console.log('isSignedIn:' + auth2.isSignedIn.get());
		updateGoogleUser(auth2.currentUser.get());
	}
}

/**
 * Signs out the current user.
 */
function signOut() {
	if (!auth2) return;
	
	auth2.signOut().then(function () {
		console.log('User signed out.');
		auth2.disconnect();
	}).catch(function(error) {
		console.error('Error signing out:', error);
	});
}



